import { Loader } from "@logora/debate.progress.loader";
import { ArrowLeftIcon } from "@mui/x-date-pickers";
import React, { useState, useEffect, useCallback, cloneElement } from "react";
import { useAuthenticated, useDataProvider, useRedirect } from "react-admin";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "./Show.module.scss";

export const Show = ({
	resourceId,
	resource,
	includes = [],
	backText,
	backLink,
	backIcon,
	onClickBackLink,
	disablePushToHistory,
	children,
}) => {
	const { id } = useParams();
	const dataProvider = useDataProvider();
	const redirectTo = useRedirect();
	const [loading, setLoading] = useState(true);
	const [record, setRecord] = useState(null);
	const navigate = useNavigate();
	const location = useLocation();

	useAuthenticated();

	const fetchRecord = useCallback(async () => {
		try {
			const response = await dataProvider.getOne(resource, {
				id: resourceId || id,
				include: includes,
			});
			const record = response.data;
			if (record) {
				setRecord(record);
				setLoading(false);
			}
		} catch (error) {
			console.log(error);
			setLoading(false);
		}
	}, [dataProvider, id, resourceId]);

	useEffect(() => {
		if (resource) {
			fetchRecord();
		}
	}, [id, resourceId]);

	if (!children) return null;

	return (
		<div className={styles.container}>
			{location.key !== "default" && (
				<button
					type="button"
					className={styles.backLink}
					onClick={() => {
						onClickBackLink?.();
						navigate(backLink || -1, {
							replace: disablePushToHistory,
						});
					}}
				>
					{backIcon ? backIcon : <ArrowLeftIcon />}
					{backText || "Retour"}
				</button>
			)}

			{loading || !record ? (
				<div className={styles.loader}>
					<Loader />
				</div>
			) : (
				<>
					{cloneElement(children, {
						resource: record,
						resourceId: resourceId || id,
					})}
				</>
			)}
		</div>
	);
};
